var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-tabs-wrapper bb-0" },
    [
      _c("scrollable-container", [
        _c(
          "ul",
          { staticClass: "nav nav-tabs scroll-container" },
          _vm._l(_vm.tabs, function (tab, key) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      disabled: !tab.disabled,
                      placement: "top",
                      title: tab.disabled,
                      boundary: "viewport",
                    },
                    expression:
                      "{\n          disabled: !tab.disabled,\n          placement: 'top',\n          title: tab.disabled,\n          boundary: 'viewport'\n        }",
                  },
                ],
                key: key,
                staticClass: "nav-item",
                class: { "navbar-active": _vm.currentTab === key },
                attrs: { id: key },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange(key, tab.disabled)
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link grey-text text-darken-3 clickable",
                    attrs: {
                      to: _vm.navigationLink(key, tab.routeName, tab.params),
                    },
                  },
                  [_vm._v("\n          " + _vm._s(tab.label) + "\n        ")]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }